import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const Contacto = () => {
  // Runtime config (window.ENV) takes priority over build-time env vars
  const serviceId = window.ENV?.REACT_APP_EMAILJS_SERVICE_ID || process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = window.ENV?.REACT_APP_EMAILJS_TEMPLATE_ID || process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = window.ENV?.REACT_APP_EMAILJS_PUBLIC_KEY || process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
  const contactEmail = window.ENV?.REACT_APP_CONTACT_EMAIL || process.env.REACT_APP_CONTACT_EMAIL;

  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      await emailjs.send(
        serviceId,
        templateId,
        {
          from_name: formData.nombre,
          from_email: formData.email,
          phone: formData.telefono,
          message: formData.mensaje,
          to_email: contactEmail
        },
        publicKey
      );

      setSubmitStatus('success');
      setFormData({
        nombre: '',
        email: '',
        telefono: '',
        mensaje: ''
      });
    } catch (error) {
      console.error('Error al enviar el formulario:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="py-16 sm:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
            {/* Left side - Contact Info */}
            <div className="text-center lg:text-left">
              <div className="mb-8">
                <p className="text-gray-500 text-sm uppercase tracking-wider mb-2">
                  ESTAMOS PARA ASESORARTE
                </p>
                <h2 className="text-4xl sm:text-5xl font-bold text-[#001F3F]">
                  Contactanos
                </h2>
              </div>

              <div className="space-y-4 flex flex-col items-center lg:items-start">
                {/* Email */}
                <div className="flex items-center gap-3 text-gray-600">
                  <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="#3799C4" strokeWidth={1.5} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                  </svg>
                  <span>federico.spasociados@gmail.com</span>
                </div>

                {/* Whatsapp */}
                <div className="flex items-center gap-3 text-gray-600">
                  <svg className="w-5 h-5 flex-shrink-0" fill="#3799C4" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                  <span>15 6532-8691</span>
                </div>
{/* Phone */}
                 <div className="flex items-center gap-3 text-gray-600">
                  <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="#3799C4" strokeWidth={1.5} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                  </svg>
                  <span>15 5008-5865</span>
                </div>

                {/* Location */}
                <div className="flex items-center gap-3 text-gray-600">
                  <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="#3799C4" strokeWidth={1.5} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                  </svg>
                  <span>Moreno 970 - 3°Piso Of 60  (CABA)</span>
                </div>
              </div>
              
            </div>

            {/* Right side - Contact Form */}
            <div className="bg-[#EFF3F8] rounded-2xl p-8 sm:p-10">
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    required
                    value={formData.nombre}
                    onChange={handleChange}
                    className="w-full px-4 py-3.5 bg-white border-0 rounded-lg focus:ring-2 focus:ring-blue-500 transition-all duration-200 text-gray-500 placeholder:text-gray-400"
                    placeholder="nombre completo"
                  />
                </div>

                <div>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3.5 bg-white border-0 rounded-lg focus:ring-2 focus:ring-blue-500 transition-all duration-200 text-gray-500 placeholder:text-gray-400"
                    placeholder="example@email.com"
                  />
                </div>

                <div>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    className="w-full px-4 py-3.5 bg-white border-0 rounded-lg focus:ring-2 focus:ring-blue-500 transition-all duration-200 text-gray-500 placeholder:text-gray-400"
                    placeholder="(123) 456 - 789"
                  />
                </div>

                <div>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    required
                    value={formData.mensaje}
                    onChange={handleChange}
                    rows="5"
                    className="w-full px-4 py-3.5 bg-white border-0 rounded-lg focus:ring-2 focus:ring-blue-500 transition-all duration-200 resize-none text-gray-500 placeholder:text-gray-400"
                    placeholder="Por favor, escribe tu mensaje aquí..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#001580] hover:bg-[#001a99] text-white font-semibold py-3.5 px-6 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar consulta'}
                </button>

                {submitStatus === 'success' && (
                  <div className="mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                    ¡Mensaje enviado con éxito! Te contactaremos pronto.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="mt-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                    Hubo un error al enviar el mensaje. Por favor, intenta nuevamente o contáctanos directamente.
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacto;
